/* eslint-disable prefer-destructuring */
// https://vitejs.dev/guide/env-and-mode.html#production-replacement
export const APP_IRE_PLAYER_WIDGET_PART_URL = import.meta.env.APP_IRE_PLAYER_WIDGET_PART_URL;
export const APP_IRE_PLAYER_WIDGET_ORIGIN = import.meta.env.APP_IRE_PLAYER_WIDGET_ORIGIN;
export const APP_TRAFFIC_MANAGER_ORIGIN = import.meta.env.APP_TRAFFIC_MANAGER_ORIGIN;
export const APP_CONFIG_BUCKET = import.meta.env.APP_CONFIG_BUCKET;
export const APP_VERSION = import.meta.env.APP_VERSION;
export const APP_BACKUP_PLAYLIST_ORIGIN = import.meta.env.APP_BACKUP_PLAYLIST_ORIGIN;
export const APP_BUILD_ENV = import.meta.env.APP_BUILD_ENV;
export const APP_CONFIG_ENV = import.meta.env.APP_CONFIG_ENV;
export const APP_DEFAULT_RESOURCES_DOMAIN = import.meta.env.APP_DEFAULT_RESOURCES_DOMAIN;
export const APP_REPLACE_RESOURCES_DOMAIN = import.meta.env.APP_REPLACE_RESOURCES_DOMAIN;
export const APP_BUILD_DATE_TIME = import.meta.env.APP_BUILD_DATE_TIME;
export const APP_SOCIAL_SHARING_ORIGIN = import.meta.env.APP_SOCIAL_SHARING_ORIGIN;
export const APP_AD_SCRIPT_PART_URL = import.meta.env.APP_AD_SCRIPT_PART_URL;
